import { FC } from "react";

interface TeamTitleProps {
    subtitle?: string;
    title: string;
    bottomTitle?:string;
    url?: string;
}

export const TeamTitle: FC<TeamTitleProps> = ({
    subtitle,
    title,
    bottomTitle,
    url,
}) => {
    let titleClassName = 'font-bold';

    if (title.length > 10) {
        titleClassName += ' text-xl';
    } else {
        titleClassName += ' text-2xl';
    }
    return (
        <div className="flex flex-row items-center gap-2 cursor-pointer" style={{
            fontFamily: 'Futura, sans-serif',
        }}
            onClick={() => url && globalThis?.location?.assign(url)}
        >
            <img src="https://academy.fcrodina.com/i/logo.png" alt="ФК Родина" className="min-w-12 h-12" />
            <div className="flex flex-col items-center justify-center">
                {subtitle && <div className="text-sm uppercase font-medium">{subtitle}</div>}
                <div className={titleClassName}>{title}</div>
                {bottomTitle && <div className="text-sm uppercase font-medium">{bottomTitle}</div>}
            </div>
        </div>
    );
}